import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import configureStore,{history} from './store/configureStore';
import App from './App';
import { unregister }  from './registerServiceWorker';
import { PersistGate } from 'redux-persist/integration/react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import ErrorHandling from './components/ErrorHandling';

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = ((window) as any).initialReduxState;
const { store, persistor } = configureStore(initialState);

const rootElement = document.getElementById('root');

function ErrorFallback({ error }: FallbackProps) {
    return (
        <ErrorHandling message={error?.message} />
    )
}

export type AppDispatch = typeof store.dispatch

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
            <ConnectedRouter history={history}>
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <App />
                </ErrorBoundary>
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    rootElement);

unregister();
